module.exports = __webpack_public_path__ + "static/fonts/PlayfairDisplay700.21988bd5.ttf";